// import axios from "axios";
import axios from "axios";
import { BASE_URL } from "./ApiConfig";
// import { BASE_URL } from "./API_Config";

export const getApiUrl = (route) => {
  return `${BASE_URL}${route}`;
};

// const cancelTokenSources = {};

export const apiGet = async (route, params) => {
  try {
    const response = await axios.get(getApiUrl(route), {
      params,
    });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error making GET request:", error);
    }
    throw error;
  }
};

export const apiPost = async (route, data) => {
  try {
    console.log("api enterd");
    console.log(route);
    console.log(data);
    console.log(getApiUrl(route), data);
    const response = await axios.post(getApiUrl(route), data);
    console.log(response);
    console.log(data);
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error making POST request:", error);
    }
    throw error;
  }
};

export const apiPut = async (route, data, cancelTokenSource = null, params) => {
  console.log("enter to the api call");
  console.log(data);
  try {
    console.log(data);
    const response = await axios.put(getApiUrl(route), data, {
      cancelToken: cancelTokenSource?.token,
      headers: {
        "Content-Type": "application/json",
      },
      params: params,
    });
    console.log(data);
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error making PUT request:", error);
    }
    throw error;
  }
};

export const apiDelete = async (route, cancelTokenSource = null) => {
  try {
    const response = await axios.delete(getApiUrl(route), {
      cancelToken: cancelTokenSource?.token,
    });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error making DELETE request:", error);
    }
    throw error;
  }
};

export const apiPatch = async (route, data, cancelTokenSource = null) => {
  try {
    const response = await axios.patch(getApiUrl(route), data, {
      cancelToken: cancelTokenSource?.token,
    });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error making PATCH request:", error);
    }
    throw error;
  }
};
